export interface AccessoryData {
  id: string;
  accIconKey: string;
  headKey: string;
  category: 'hat' | 'glasses' | 'hood' | 'ornament';
  enabled: boolean;
}

export const ACCESSORIES: Record<string, AccessoryData> = {
  cowboyhat: {
    id: 'cowboyhat',
    accIconKey: 'acc_cowboyhat',
    headKey: 'head_cowboyhat',
    category: 'hat',
    enabled: true,
  },
  lion: {
    id: 'lion',
    accIconKey: 'acc_lion',
    headKey: 'head_lion',
    category: 'hood',
    enabled: true,
  },
  rabbit: {
    id: 'rabbit',
    accIconKey: 'acc_rabbit',
    headKey: 'head_rabbit',
    category: 'hood',
    enabled: true,
  },
  sunglass: {
    id: 'sunglass',
    accIconKey: 'acc_sunglass',
    headKey: 'head_sunglass',
    category: 'glasses',
    enabled: true,
  },
  susi: {
    id: 'susi',
    accIconKey: 'acc_susi',
    headKey: 'head_susi',
    category: 'ornament',
    enabled: true,
  },
};

export const PHASE1_ACCESSORY: AccessoryData = ACCESSORIES.cowboyhat;

export function getHeadKeyForAccessory(accKey: string): string {
  return accKey.replace('acc_', 'head_');
}

export function getAllAccessories(): AccessoryData[] {
  return Object.values(ACCESSORIES);
}
